import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import moment from "moment"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const ticketList = createAsyncThunk('ticket/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `ticket`,
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                premise_id: data?.premise_id,
                unit_id: data?.unit_id,
                complaint_category_id: data?.complaint_category,
                incident_type: data?.complaint_type,
                incident_priority: data?.priority,
                incident_status: data?.status,
                admin: data?.admin,
                incident_date: data?.incident_date
                    ? (moment(data.incident_date, 'YYYY-MM-DD', true).isValid()
                        ? data.incident_date
                        : moment(data.incident_date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
                    : undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const ticketDetails = createAsyncThunk('ticket/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `ticket/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addTicket = createAsyncThunk('ticket/add', async (data) => {
    var bodyFormData = new FormData()

    bodyFormData.append("premise_id", data?.values?.premise_id ?? '')
    bodyFormData.append("zone_id", data?.values?.zone_id ?? '')
    bodyFormData.append("level_id", data?.values?.level_id ?? '')
    bodyFormData.append("unit_id", data?.values?.unit_id ?? '')
    bodyFormData.append("complaint_category_id", data?.values?.complaint_category ?? '')
    bodyFormData.append("incident_type", data?.values?.complaint_type ?? '')
    bodyFormData.append("incident_priority", data?.values?.priority ?? '')
    bodyFormData.append("incident_title", data?.values?.subject ?? '')
    bodyFormData.append("incident_remark", data?.values?.description ?? '')
    bodyFormData.append("incident_date", data?.values?.incident_date && moment(data?.values?.incident_date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
    bodyFormData.append("incident_time", data?.values?.incident_time ?? '')

    if (data?.values?.attachments && Array.isArray(data?.values?.attachments)) {
        data.values.attachments.forEach((file) => {
            bodyFormData.append("ticket_file", file)
        })
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'ticket',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "ticket_file", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateTicket = createAsyncThunk('ticket/update', async (data) => {
    var bodyFormData = new FormData()

    bodyFormData.append("ticket_id", data?.values?.id)
    bodyFormData.append("premise_id", data?.values?.premise_id ?? '')
    bodyFormData.append("zone_id", data?.values?.zone_id ?? '')
    bodyFormData.append("level_id", data?.values?.level_id ?? '')
    bodyFormData.append("unit_id", data?.values?.unit_id ?? '')
    bodyFormData.append("complaint_category_id", data?.values?.complaint_category ?? '')
    bodyFormData.append("incident_type", data?.values?.complaint_type ?? '')
    bodyFormData.append("incident_priority", data?.values?.priority ?? '')
    bodyFormData.append("incident_title", data?.values?.subject ?? '')
    bodyFormData.append("incident_remark", data?.values?.description ?? '')
    bodyFormData.append("incident_date", data?.values?.incident_date && moment(data?.values?.incident_date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
    bodyFormData.append("incident_time", data?.values?.incident_time ?? '')

    if (data?.values?.attachments && Array.isArray(data?.values?.attachments)) {
        data.values.attachments.forEach((file) => {
            bodyFormData.append("ticket_file", file)
        })
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_ticket',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "ticket_file", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delTicket = createAsyncThunk('ticket/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `ticket/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateTicketStatus = createAsyncThunk('ticket/updateStatus', async ({ ticket_id, incident_status, ticket_file }) => {
    const bodyFormData = new FormData()
    bodyFormData.append('ticket_id', ticket_id)
    bodyFormData.append('incident_status', incident_status)
    if (Array.isArray(ticket_file)) {
        ticket_file.forEach((file) => {
            bodyFormData.append('ticket_file', file)
        })
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'ticket_status',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "type": "ticket_file", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const assignTicket = createAsyncThunk('ticket/assign', async ({ ticket_id, user_id }) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'ticket_assign',
            data: {
                ticket_id,
                user_id
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delTicketFile = createAsyncThunk('ticket/deleteFile', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `ticket_file/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const ticket = createSlice({
    name: 'ticket',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ticketList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })

        builder.addCase(ticketDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        })
    }
})

export default ticket.reducer